export * from './taxes/taxes.page';
